import { useFormContext } from "react-hook-form";
import type { UseMutationOptions } from "react-query";
import { useMutation } from "react-query";
import { workflowsApi } from "@/react/api";
import type { Action } from "../generated/WorkflowsApi.types";

export const upsertAction = (workflowId: string, action: Action) => {
  const { id, action_type, api_params, position = 1 } = action;

  if (!id || id.startsWith("action")) {
    return workflowsApi.createAction({
      workflowId,
      body: {
        action_type,
        api_params,
        position,
      },
    });
  }

  return workflowsApi.updateAction({
    workflowId,
    id,
    body: {
      action_type,
      api_params,
      position,
    },
  });
};

export const useUpsertAction = (
  options: UseMutationOptions<Action, Error, Action> = {},
) => {
  const { watch } = useFormContext();
  const workflowId = watch("id");
  return useMutation(
    (action: Action) => upsertAction(workflowId, action),
    options,
  );
};
